const linkify = require("linkifyjs");
import { PermissionCodes } from "@/lib/utilities/enums";
import { exists } from "@/lib/utilities/index";
import store from "../../store";

const ID_STR_RE = /[^A-Za-z0-9-_:]/g;
export function cleanIdString(str) {
  if (typeof str !== "string") return undefined;
  return str.toLowerCase().replace(ID_STR_RE, "-");
}

export const HelperFunctions = {
  getUserById(userId) {
    let appUsers = store.getters.AllUsers;
    if (userId && userId.length > 0 && appUsers && appUsers.length > 0) {
      let user = appUsers.find(x => x.Id == userId);
      return user && user.Id
        ? user.Name
        : userId.startsWith("1:")
          ? "System"
          : "N/A";
    }
    return "N/A";
  },
  getOrLoadDealerSettings(platformId) {
    return new Promise(resolve => {
      if (!platformId) {
        resolve(null);
        return;
      }
      store
        .dispatch("loadDealerSettings", {
          AccountPlatformID: platformId
        })
        .then(response => {
          resolve(response);
        })
        .catch(() => {
          resolve(null);
        });
    });
  },
  getOrLoadDealerPackage(platformId) {
    return new Promise((resolve, reject) => {
      if (!platformId) {
        resolve(null);
        return;
      }
      let settings = store.getters.DealersPackages(platformId);
      if (!settings) {
        store
          .dispatch("getDealersPackages", platformId)
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            resolve(null);
          });
      } else {
        resolve(settings);
      }
    });
  },
  async getOrLoadCXM_AM_DealerSettings(dealerId) {
    if (!dealerId)
      return null;

    if (store.getters.CXM_AM_DealerSettingsList && store.getters.CXM_AM_DealerSettingsList.some(x => x.dealerId == dealerId))
      return store.getters.CXM_AM_DealerSettingsList.find(x => x.dealerId == dealerId).settings;

    let response = await store.dispatch("getDealerInfo", dealerId);
    store.dispatch("updateCXM_AM_DealerSettingsList", response);
    return response;
  },
  hasPermission(user, permissions, requireAll = false) {
    if (!exists(permissions)) {
      console.warn("hasPermission: No permissions to check, returning false");
      return false;
    }
    if (!Array.isArray(permissions)) permissions = [permissions];
    if (
      !user ||
      !Array.isArray(user.Permissions) ||
      user.Permissions.length == 0
    ) {
      console.warn("hasPermission: Invalid user, returning false");
      return false;
    }

    if (permissions.length == 0) return true;
    permissions = permissions.map(permID => PermissionCodes[permID]);
    const filterFn = permToCheck => {
      return permToCheck && user.Permissions.find(p => p == permToCheck);
    };
    return requireAll
      ? permissions.every(filterFn)
      : permissions.some(filterFn);
  },
  sortByProperty: function (property) {
    return function (a, b) {
      return a[property].toLowerCase() === b[property].toLowerCase()
        ? 0
        : a[property].toLowerCase() > b[property].toLowerCase()
          ? 1
          : -1;
    };
  },
  sortByTwoProperties: function (primarySort, secondarySort) {
    return function (a, b) {
      return a[primarySort].toLowerCase() === b[primarySort].toLowerCase()
        ? a[secondarySort].toLowerCase() === b[secondarySort].toLowerCase()
          ? 0
          : a[secondarySort].toLowerCase() > b[secondarySort].toLowerCase()
            ? 1
            : -1
        : a[primarySort].toLowerCase() > b[primarySort].toLowerCase()
          ? 1
          : -1;
    };
  },
  parseToJSONString: function (object) {
    if (object) {
      try {
        return JSON.stringify(object);
      } catch (ex) {
        return null;
      }
    }
  },
  parseStringToJSON: function (value) {
    try {
      return value ? JSON.parse(value) : null;
    } catch (e) {
      return null;
    }
  },
  sortByPropertyAsc: function (property) {
    return function (a, b) {
      let valueOfA = a[property]
        ? typeof a[property] == "number"
          ? a[property]
          : a[property].toLowerCase()
        : "";
      let valueOfB = b[property]
        ? typeof b[property] == "number"
          ? b[property]
          : b[property].toLowerCase()
        : "";
      return valueOfA === valueOfB ? 0 : valueOfA > valueOfB ? 1 : -1;
    };
  },
  sortByPropertyDesc: function (property) {
    return function (a, b) {
      let valueOfA = a[property]
        ? typeof a[property] == "number"
          ? a[property]
          : a[property].toLowerCase()
        : "";
      let valueOfB = b[property]
        ? typeof b[property] == "number"
          ? b[property]
          : b[property].toLowerCase()
        : "";

      return valueOfA === valueOfB ? 0 : valueOfA > valueOfB ? -1 : 1;
    };
  },
  getOrLoadEmailTemplates(platformId) {
    return new Promise((resolve, reject) => {
      if (!platformId) {
        resolve(null);
        return;
      }
      let dealerInfo = store.getters.DealerEmailTemplates(platformId);
      if (!dealerInfo) {
        store
          .dispatch("getEmailTemplatesForPlatform", platformId)
          .then(response => {
            if (response) resolve(response);
            else resolve([]);
          })
          .catch(err => {
            resolve([]);
          });
      } else {
        resolve(dealerInfo.templates);
      }
    });
  },
  escapeHtml: function (text) {
    //Escape html tags
    try {
      //If there is any user entered markup html in the message, escape it
      if (text && text.trim()) {
        return text
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      }
    } catch (err) { }
    return text;
  },
  isValidEmail(emailAddress) {
    try {
      if (!emailAddress || !emailAddress.trim()) return false;
      const links = linkify.find(this.escapeHtml(emailAddress));
      return links && links.length > 0 && links[0].type == "email";
    } catch (err) {
      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/lib/utilities/HelperFunctions.js